import commonSlice from '@/state/common.slice';
import store from '@/state/store';

export default () => {
  store.dispatch(commonSlice.actions.hideApplicationBlocked());
};